import React from "react";
import { Breadcrumb as Bc } from "react-bootstrap";
import { useNavigate } from "react-router";

const Breadcrumb = ({ activeLabel }) => {
    const nav = useNavigate();
    return (
        <div className="my-3">
            <Bc>
                <Bc.Item href="#" title="Home" onClick={() => nav("/")}>
                    Home
                </Bc.Item>
                <Bc.Item
                    href="#"
                    title="Wishlist"
                    onClick={() => nav("/wishlist")}
                >
                    Wishlist
                </Bc.Item>
                <Bc.Item active className="text-truncate">
                    {activeLabel}
                </Bc.Item>
            </Bc>
        </div>
    );
};

export default Breadcrumb;
